import React, { useEffect } from 'react'
import { LoaderProps } from './types'
import { GET_MERCHANT_MODIFIER_GROUPS } from 'components/Locations/Dashboard/DashboardQueries'
import { useSession } from 'packages/@slerp/accounts'
import { useLazyQuery } from '@apollo/client'
import { useModifierGroups } from 'hooks/useGlobalContext/useModifierGroups'
import { ModifierGroup } from 'components/Locations/Dashboard/types'

export const MerchantModifierGroupsLoader = ({
  isParentLoaded = true,
  children
}: LoaderProps) => {
  const { merchant } = useSession()
  const { hasModifierGroups, needsFetch, setModifierGroups } =
    useModifierGroups()

  const [getMerchantModifierGroups, { data, error }] = useLazyQuery<{
    modifier_groups: ModifierGroup[]
  }>(GET_MERCHANT_MODIFIER_GROUPS, {
    variables: { merchantId: merchant?.id },
    fetchPolicy: 'no-cache'
  })

  useEffect(() => {
    if (!merchant?.id || !needsFetch) {
      return
    }

    getMerchantModifierGroups()
  }, [merchant?.id, needsFetch])

  useEffect(() => {
    if (data?.modifier_groups) {
      setModifierGroups(data.modifier_groups)
    }
  }, [data])

  // Gate on the cache, not on the lazy query's `loading`, which is still false
  // before the query fires - long enough to mount children against an empty
  // group list. Nothing to fetch without a merchant, and a failed query never
  // caches, so both open the gate rather than spinning forever. A merchant
  // with no groups caches an empty list, so it opens the gate normally.
  const isLoaded =
    isParentLoaded && (hasModifierGroups || !merchant?.id || !!error)

  return <React.Fragment>{children(isLoaded)}</React.Fragment>
}
